/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import useUtils from './useUtils'
import Pagination from '../../modules/pagination/Pagination'
import TableSkeleton from '../../modules/skeleton/TableSkelton'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import {saveAs} from 'file-saver'
import {unparse} from 'papaparse'
import Papa from 'papaparse'
import {showAlert} from '../../redux/reducers/alertSlice'
import CSVModal from '../../modules/modal/CSVModal'
import {useHelper} from '../../../_metronic/helpers/useHelper'
import UploadAlert from '../../modules/alert/UploadingAlert'
import {useBlocker} from '../../../_metronic/helpers/useBloker'
const ProgramList = ({className}) => {
  const {
    addCSV,
    fetchCohorts,
    fetchCategories,
    fetchAllPrograms,
    fetchPrograms,
    fetchLanguages,
    handleEdit,
    deleteProgram,
    fetchSeasons,
    submitReport,
  } = useUtils()
  const previousSearchTerm = useRef('')
  const fileInputRef = useRef(null)

  const {createSmartChunks} = useHelper()
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const pendingTxRef = useRef(null)

  const [isOpen, setIsOpen] = useState(false)
  const [csvData, setcsvData] = useState(null)
  const [isUpload, setIsUpload] = useState(false)

  const [searchTerm, setSearchTerm] = useState('')
  const [programs, setPrograms] = useState(null)
  const cohortOptions = useSelector((state) => state?.cohort?.records)
  const categoryOptions = useSelector((state) => state?.category.records)
  const seasonsOptions = useSelector((state) => state?.season.records)
  const [loading, setLoading] = useState(true)
  const statusOptions = ['drafts', 'published']

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)

  const [downloadLoading, setDownloadLoading] = useState(false)
  const [uploadLoading, setUploadLoading] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  dispatch(setTitle('Program'))

  const [selectedStatus, setSelectedStatus] = useState(null)
  const [selectedCohort, setSelectedCohort] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedSeason, setSelectedSeason] = useState(null)

  const count = programs?.count

  useBlocker((tx) => {
    pendingTxRef.current = tx
    setShowConfirmModal(true)
  }, uploadLoading)

  const handleConfirmLeave = () => {
    setShowConfirmModal(false)
    window.location.href = document.referrer || '/'
  }

  const handleCancelLeave = () => {
    pendingTxRef.current = null
    setShowConfirmModal(false)
  }

  const getPrograms = async () => {
    try {
      if (searchTerm === previousSearchTerm.current) {
        setLoading(true)
      }
      const offset = (page - 1) * limit
      const result = await fetchPrograms(
        searchTerm,
        selectedStatus,
        selectedCohort,
        selectedCategory,
        selectedSeason,
        limit,
        offset
      )
      setTotalPages(Math.ceil(result?.count / limit))
      setPrograms(result)

      previousSearchTerm.current = searchTerm
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(
      () => {
        getPrograms()
      },
      searchTerm ? 500 : 0
    )
    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, selectedStatus, selectedCohort, selectedSeason, limit, selectedCategory, page])

  useEffect(() => {
    fetchCohorts()
    fetchCategories()
    fetchLanguages()
    fetchSeasons()
  }, [])

  const handleDelete = (id) => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await deleteProgram(selectedId, limit, (page - 1) * limit)
      setPrograms(result)
    } catch (error) {
      console.error('Error deleting course:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  const handleStatusChange = (status) => {
    setSelectedStatus(status)
  }

  const handleCohortChange = (cohortId) => {
    setSelectedCohort(cohortId)
  }

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId)
  }

  const handleSeasonChange = (seasonId) => {
    setSelectedSeason(seasonId)
  }

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (uploadLoading && showConfirmModal) {
        e.preventDefault()
        e.returnValue = ''
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [uploadLoading, showConfirmModal])

  const onPreview = async (id) => {
    const result = await handleEdit(id)
    let values = {
      code: result?.code,
      id: result.id,
      title: result?.title,
      authorName: result?.authorName,
      category: result?.category?.name,
      imgUrl: result?.imageUrl,
      bannerImage: null,
      cohorts:
        result.programCohort
          ?.map((pc) => pc.cohort?.title)
          .filter(Boolean)
          .join(', ') || 'N/A',
      shortDescription: result?.shortDescription,
      longDescription: result?.longDescription,
      language: result?.language?.name,
      courses: result?.programCourse
        ?.filter((mu) => mu?.course !== null)
        ?.map((mu) => mu?.course?.title),
      tags: result?.tag?.map((tags) => tags.name),
      learningPoints: result?.learningPoint.map((lp) => lp?.name),
      status: result?.status,
      isFeatured: result?.isFeatured,
      isForBlackforceMembers: result?.isForBlackforceMembers,
      seasonId: result?.season?.id,
    }
    navigate('/programlist/preview-program', {state: {values}})
  }

  const onEdit = async (id) => {
    const result = await handleEdit(id)
    navigate('/programlist/editProgram', {state: {result}})
  }

  const handleDownload = async () => {
    try {
      setDownloadLoading(true)
      const data = await fetchAllPrograms(
        searchTerm,
        selectedStatus,
        selectedCohort,
        selectedCategory,
        selectedSeason
      )
      const csv = unparse(data, {header: true})
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      saveAs(blob, 'programs.csv')
    } catch (error) {
      console.error('Error downloading programs:', error)
    } finally {
      setDownloadLoading(false)
    }
  }

  const uploadFile = async (data) => {
    let successRecords = 0
    const failedRecords = []
    try {
      const chunks = createSmartChunks(data)
      const uploadPromises = chunks.map((chunk) => addCSV(chunk))
      const response = await Promise.all(uploadPromises)
      response.forEach((response) => {
        if (response.success) {
          successRecords += response.success
        }
        if (response.failed?.length > 0) {
          failedRecords.push(...response.failed) // Aggregate failed records
        }
      })

      const successMessage = successRecords
        ? `${successRecords} programs uploaded successfully`
        : ''
      const failedMessage = failedRecords.length
        ? `${failedRecords.length} programs failed to upload`
        : ''
      const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
      dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))

      const finalSummary = {
        recordType: 'Programs',
        totalRecords: data.length,
        successRecords: successRecords,
        failedRecords: failedRecords,
      }

      const res = await submitReport(finalSummary)
      if (res) {
        dispatch(
          showAlert({message: 'Report Submitted Successfully', variant: 'info', timeout: 5000})
        )
      } else {
        console.log('Error')
      }
    } catch (error) {
      console.error('Error uploading programs:', error)
    } finally {
      setUploadLoading(false)
      getPrograms()
    }
  }

  const handleFileChange = (event) => {
    setUploadLoading(true)
    const file = event.target.files[0]
    if (file) {
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        Papa.parse(file, {
          header: true,
          complete: (result) => {
            const filteredData = result.data.filter((row) =>
              Object.values(row).some((value) => value && value.trim() !== '')
            )
            setIsOpen(true)
            setcsvData(filteredData)
            event.target.value = null
          },
          error: (error) => {
            console.error('Error parsing CSV:', error)
          },
        })
      } else {
        dispatch(showAlert({message: 'Please select a valid CSV file.', variant: 'danger'}))
      }
    }
  }

  useEffect(() => {
    if (csvData) {
      const transformedData = csvData?.map((obj, index) => ({
        id: obj?.id,
        title: obj?.title,
        authorName: obj?.authorName,
        code: obj?.code,
        shortDescription: obj?.shortDescription,
        longDescription: obj?.longDescription,
        isFeatured: obj?.isFeatured ? true : false,
        categoryId: obj?.category,
        languageId: obj?.language,
        cohortIds: obj?.cohorts ? obj.cohorts?.split(',').map((id) => id.trim()) : [],
        seasonId: obj?.season,
        courseIds: obj?.courses ? obj.courses?.split(',').map((id) => id.trim()) : [],
        isForBlackforceMember: obj?.ForBlackforceMember ? true : false,
        tags: obj.tags ? obj.tags.split(',').map((tag) => tag.trim()) : [],
        learningPoints: obj.learningPoints
          ? obj.learningPoints.split(',').map((learningPoints) => learningPoints.trim())
          : [],
      }))
      uploadFile(transformedData)
      setcsvData(null)
    }
  }, [isUpload])

  if (loading) return <TableSkeleton />

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start'>
          <span className='mt-1 text-muted fs-7'>
            {count} {count <= 1 ? 'Item' : 'items'}
          </span>
        </h3>
        <div className='mt-5 d-flex align-items-center justify-content-between w-100 flex-wrap'>
          <div className='d-flex align-items-center flex-wrap gap-3'>
            {/* begin::Search */}
            <div className='d-flex align-items-center'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-3 position-absolute ms-6'
              />
              <input
                disabled={uploadLoading}
                type='text'
                data-kt-user-table-filter='search'
                className='form-control fs-7 form-control-solid w-250px h-40px ps-14'
                placeholder='Search Programs'
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value)
                  setPage(1)
                }}
              />
              {/* end::Search */}
            </div>

            <div>
              <select
                disabled={uploadLoading}
                value={selectedCategory || ''}
                className='form-select form-select-solid fs-7 h-40px w-150px text-muted select2-hidden-accessible'
                onChange={(e) => handleCategoryChange(e.target.value)}
              >
                <option value={null}>Category</option>
                {categoryOptions.map((category, index) => (
                  <option key={index} value={category.id} data-select2-id='select2-data-12-vz6w'>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <select
                disabled={uploadLoading}
                value={selectedStatus || ''}
                className='form-select form-select-solid fs-7 text-muted h-40px  w-150px select2-hidden-accessible'
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option value={null}>Status</option>
                {statusOptions.map((status, index) => (
                  <option key={index} value={status} data-select2-id='select2-data-12-vz6w'>
                    {status}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <select
                disabled={uploadLoading}
                value={selectedCohort || ''}
                className='form-select fs-7 form-select-solid h-40px text-muted  w-150px select2-hidden-accessible'
                onChange={(e) => handleCohortChange(e.target.value)}
              >
                <option>Cohort</option>
                {cohortOptions.map((cohort, index) => (
                  <option key={index} value={cohort.id}>
                    {cohort.title}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <select
                disabled={uploadLoading}
                value={selectedSeason || ''}
                className='form-select fs-7 form-select-solid h-40px text-muted  w-150px select2-hidden-accessible'
                onChange={(e) => handleSeasonChange(e.target.value)}
              >
                <option>Season</option>
                {seasonsOptions.map((season, index) => (
                  <option key={index} value={season.id}>
                    {season.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='card-toolbar'>
            <div>
              <span
                onClick={() => fileInputRef.current.click()}
                className='btn btn-sm  btn-light-primary me-2'
              >
                {uploadLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <>
                    <KTSVG path='/media/icons/duotune/files/fil010.svg' className='svg-icon-2' />
                    Upload CSV
                  </>
                )}
              </span>
              <input
                type='file'
                ref={fileInputRef}
                style={{display: 'none'}}
                accept='.csv'
                onChange={handleFileChange}
              />
            </div>

            <span
              onClick={() => (!uploadLoading ? handleDownload() : null)}
              className={`btn btn-sm  btn-light-primary me-2 ${uploadLoading ? 'disabled' : ''}`}
            >
              {downloadLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                <>
                  <KTSVG path='/media/icons/duotune/files/fil003.svg' className='svg-icon-2 me-1' />
                  Download CSV
                </>
              )}
            </span>

            <span
              onClick={() => (!uploadLoading ? navigate('/programlist/addProgram') : null)}
              className={`btn btn-sm  btn-light-primary  ${uploadLoading ? 'disabled' : ''}`}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              Add Programs
            </span>
          </div>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      {count === 0 && (
        <div className='mt-20 mb-20 w-sm-100 w-md-75 mx-auto p-5 py-20'>
          <div className='card-body text-center'>
            <span className='svg-icon svg-icon-2hx svg-icon-info mb-5'>
              <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x' />
            </span>
            <h4 className='mb-1'>No Records Found</h4>
            <span>Add more Programs or change the filters</span>
          </div>
        </div>
      )}

      {count > 0 && (
        <div className='card-body py-10'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead className='align-top'>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-100px'>CODE</th>
                  <th className='min-w-200px'>ID</th>
                  <th className='min-w-200px'>TITLE</th>
                  <th className='min-w-100px'>CATEGORY</th>
                  <th className='min-w-100px'>AUTHOR NAME</th>
                  <th className='min-w-100px'>COHORT</th>
                  <th className='min-w-100px'>LANGUAGES</th>
                  <th className='min-w-100px'>STATUS</th>
                  <th className='min-w-150px text-end'>ACTIONS</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {programs?.records &&
                  programs?.records?.map((value, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span className='text-dark  fw-bold  fs-6'>{value.code}</span>
                        </td>
                        <td className='text-nowrap'>
                          <span className='text-dark fw-bold  fs-6'>{value.id}</span>
                        </td>
                        <td>
                          <span className='text-dark text-nowrap fw-bold  fs-6'>{value.title}</span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold  d-block mb-1 fs-6'>
                            {value.category?.name}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold  d-block mb-1 fs-6'>
                            {value.authorName}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark  fw-bold  d-block mb-1 fs-6'>
                            {value.programCohort
                              ?.map((pc) => pc.cohort?.title)
                              .filter(Boolean)
                              .join(', ') || 'N/A'}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark  fw-bold  d-block mb-1 fs-6'>
                            {value.language?.name}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              value.status === 'published' ? 'badge-success' : 'badge-danger'
                            }`}
                          >
                            {value.status}
                          </span>
                        </td>

                        <td className='d-flex justify-content-end'>
                          <span
                            onClick={() => (!uploadLoading ? onPreview(value.id) : null)}
                            className={`btn btn-icon btn-bg-light  ${
                              uploadLoading ? 'disabled' : ''
                            } btn-active-color-primary btn-sm me-1`}
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen019.svg'
                              className='svg-icon-3 svg-icon-primary'
                            />
                          </span>
                          <span
                            onClick={() => (!uploadLoading ? onEdit(value.id) : null)}
                            className={`btn btn-icon btn-bg-light  ${
                              uploadLoading ? 'disabled' : ''
                            } btn-active-color-primary btn-sm me-1`}
                          >
                            <KTSVG
                              path='/media/icons/duotune/art/art005.svg'
                              className='svg-icon-3 svg-icon-primary'
                            />
                          </span>
                          <span
                            onClick={() => (!uploadLoading ? handleDelete(value.id) : null)}
                            className={`btn btn-icon btn-bg-light  ${
                              uploadLoading ? 'disabled' : ''
                            } btn-active-color-primary btn-sm me-1`}
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen027.svg'
                              className='svg-icon-3 text-danger'
                            />
                          </span>
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
      )}
      <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
        <div className='d-flex align-items-center gap-3'>
          <span className='fs-6 text-muted'>Show</span>
          <div>
            <select
              defaultValue={limit}
              disabled={uploadLoading}
              className={`form-select form-select-solid text-muted select2-hidden-accessible`}
              onChange={(e) => {
                setPage(1)
                setLimit(e.target.value)
              }}
            >
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
        </div>
        <DeleteConfirmation
          isVisible={modalVisible}
          message='Are you sure you want to delete this Program?'
          onConfirm={confirmDelete}
          onCancel={() => setModalVisible(false)}
        />
        {isOpen && (
          <CSVModal
            show={isOpen}
            upload={() => setIsUpload((prev) => !prev)}
            handleClose={() => {
              setIsOpen(false)
            }}
            handleCancel={() => {
              setUploadLoading(false)
              setIsOpen(false)
            }}
            csvData={csvData}
          />
        )}
        <UploadAlert
          isVisible={showConfirmModal}
          message='Data is being uploaded. Are you sure you want to leave?'
          onConfirm={handleConfirmLeave}
          onCancel={handleCancelLeave}
        />
        <Pagination
          isDisable={uploadLoading}
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </div>
      {/* begin::Body */}
    </div>
  )
}

export default ProgramList
